const URL_TXT = "360immoinvest.com/simulateur-lmnp-2027";
const fmt = (v) => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.max(0, Math.round(v)));

function wrap(ctx, text, x, y, maxW, lh) {
  const words = text.split(" ");
  let line = "";
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y); line = w; y += lh; } else line = t;
  }
  ctx.fillText(line, x, y);
}

export function buildShareImage(extraYear) {
  const c = document.createElement("canvas");
  c.width = 1080; c.height = 1080;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0f2a20"; ctx.fillRect(0, 0, 1080, 1080);
  ctx.fillStyle = "#c9a24b"; ctx.fillRect(90, 150, 120, 8);
  ctx.fillStyle = "rgba(255,255,255,0.7)"; ctx.font = "600 40px Georgia, serif";
  ctx.fillText("Simulateur LMNP 2027", 90, 240);
  ctx.fillStyle = "#ffffff"; ctx.font = "600 66px Georgia, serif";
  const msg = extraYear > 0.5 ? `Mon impôt LMNP pourrait augmenter de ${fmt(extraYear)} €/an.` : "Mon impôt LMNP ne devrait pas augmenter.";
  wrap(ctx, msg, 90, 400, 900, 86);
  ctx.fillStyle = "#c9a24b"; ctx.font = "700 92px Georgia, serif";
  ctx.fillText("Et vous ?", 90, 720);
  ctx.fillStyle = "rgba(255,255,255,0.85)"; ctx.font = "500 36px Arial, sans-serif";
  ctx.fillText(URL_TXT, 90, 900);
  ctx.fillStyle = "rgba(255,255,255,0.45)"; ctx.font = "400 24px Arial, sans-serif";
  ctx.fillText("Projet de loi de finances 2027, non adopté. Estimation indicative.", 90, 960);
  return new Promise((resolve) => c.toBlob(resolve, "image/png"));
}

export async function shareLmnpResult(extraYear) {
  const blob = await buildShareImage(extraYear);
  const file = new File([blob], "simulation-lmnp-2027.png", { type: "image/png" });
  const text = extraYear > 0.5 ? `Mon impôt LMNP pourrait augmenter de ${fmt(extraYear)} €/an. Et vous ?` : "Le budget 2027 et le LMNP : faites votre simulation.";
  const url = `https://www.${URL_TXT}`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], text, url }); return; } catch (e) { if (e?.name === "AbortError") return; }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
